import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to element matching location.hash on every route change.
 * Used by App.js so navigating from /blog -> /#contact lands on the
 * contact section, not just the top of the homepage.
 */
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      // No hash — scroll top on path change for new pages
      window.scrollTo({ top: 0, behavior: 'instant' });
      return;
    }
    // Wait one frame for the new page's DOM to mount, then scroll
    const id = hash.startsWith('#') ? hash.slice(1) : hash;
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
